import { render, staticRenderFns } from "./ModelPdfView.vue?vue&type=template&id=6ba495b0"
import script from "./ModelPdfView.vue?vue&type=script&lang=js"
export * from "./ModelPdfView.vue?vue&type=script&lang=js"
import style0 from "./ModelPdfView.vue?vue&type=style&index=0&id=6ba495b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports